<template>
  <div class="d-flex flex-column">
    <div
      class="alg-slf-flex-start avl-txt"
      v-if="installedVendors.length !== 0"
    >
      <span class="heading">
        {{ $t('installed') }} ( {{ installedVendors.length }} )
      </span>
    </div>
    <div class="d-flex" v-if="dataFetched && installedVendors.length !== 0">
      <IntegrationContainer
        @onInstall="onInstall"
        :viewType="config.VIEW_TYPE.INSTALLED"
        :data="installedVendors"
      />
    </div>
    <div class="alg-slf-flex-start avl-txt">
      <span class="heading">
        {{ $t('available') }} ( {{ avalVendors.length }} )
      </span>
    </div>
    <div v-if="dataFetched && avalVendors.length !== 0" class="d-flex">
      <IntegrationContainer
        @onInstall="onInstall"
        :viewType="config.VIEW_TYPE.AVAILABLE"
        :data="avalVendors"
      />
    </div>
    <div v-if="showWindow">
      <IntegrationWindow
        @editProject="editProject"
        @uploadProject="uploadProject"
        :projects="projects"
        :serviceName="currentInstall"
        @onUninstall="openUnistallDialog"
        @onClose="
          () => {
            showWindow = false;
          }
        "
      />
    </div>

    <RexModalV3
      width="85rem"
      :show="showUnInsl"
      :enableFooter="true"
      @onClose="onUnistallDialogClose"
      :title="$t('aws.uninstall-integrations')"
    >
      <template #body>
        <div class="d-flex flex-column">
          <div class="d-flex confirm-box">
            <p class="confirm-msg">
              {{
                $t(
                  'aws.are-you-sure-you-want-to-uninstall-google-cloud-platform-integration',
                )
              }}
            </p>
          </div>
          <div class="d-flex wrning-bx">
            <p class="wring-text">
              {{
                $t(
                  'aws.all-projects-will-be-deleted-and-this-action-cannot-be-undone',
                )
              }}
            </p>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="d-flex">
          <RexButtonV3
            id="cloud-uninstall-btn-confirm"
            class="cloud-settings-footer-btn"
            @onClick="onUnistallDialogClose"
            variant="primary"
          >
            {{ $t('aws.cancel') }}
          </RexButtonV3>
          <RexButtonV3
            id="cloud-uninstall-btn-confirm"
            class="cloud-settings-footer-btn"
            @onClick="uninstallSvc"
            variant="default"
          >
            {{ $t('aws.uninstall') }}
          </RexButtonV3>
        </div>
      </template>
    </RexModalV3>
  </div>
</template>
<script>
import IntegrationContainer from '@/components/Cloud/Settings/integration-container';
import IntegrationWindow from '@/components/Cloud/Settings/integration-window';
import { mapActions, mapState } from 'vuex';
import { config } from './util';
import { CloudService } from '@/services/api/integration.service';
import RexModalV3 from '@/rex-components/RexModalV3.vue';
import RexButtonV3 from '@/rex-components/RexButtonV3.vue';
import Vue from 'vue';
import { notificationSucess, notificationError } from '@/utils/notification';
import {
  GET_VENDOR,
  GET_INSTALLED_VENDORS,
  GET_ALL_PROJECTS,
  UPLOAD_PROJECT,
  SET_ALL_VENDORS,
  SET_INSTALLED_VENDORS,
  SET_ALL_PROJECTS,
} from '@/store/modules/cloud/integrations/integration.constants';

export default {
  components: {
    IntegrationContainer,
    IntegrationWindow,
    RexModalV3,
    RexButtonV3,
  },
  methods: {
    ...mapActions('cloudState/integrations', [
      GET_VENDOR,
      GET_INSTALLED_VENDORS,
      GET_ALL_PROJECTS,
      UPLOAD_PROJECT,
    ]),
    onInstall(svcName) {
      if (svcName === 'AWS') {
        return this.$router.push('/integrations/aws');
      }
      this.currentInstall = svcName;
      this.showWindow = true;
      this.GET_ALL_PROJECTS(svcName);
    },
    async uploadProject(projectPayload, svcName) {
      const {
        data: { success },
      } = await CloudService.uploadProject(projectPayload);
      if (success) notificationSucess(config.MESSAGES.ADD_PROJECT.SUCCESS);
      else notificationError(config.MESSAGES.ADD_PROJECT.ERROR);

      this.GET_ALL_PROJECTS(svcName);
      this.GET_VENDOR();
    },
    async editProject(projectPayload, svcName) {
      const {
        data: { success },
      } = await CloudService.editProject(projectPayload);
      if (success) notificationSucess(config.MESSAGES.UPATE_PROJECT.SUCCESS);
      else notificationError(config.MESSAGES.UPATE_PROJECT.ERROR);

      this.GET_ALL_PROJECTS(svcName);
    },
    async uninstallSvc() {
      const {
        data: { success },
      } = await CloudService.deleteCloudSvc(this.currentUninstlSvc);
      if (success)
        notificationSucess(config.MESSAGES.UNINSTALL_INTEGRATION.SUCCESS);
      else notificationError(config.MESSAGES.UNINSTALL_INTEGRATION.ERROR);
      this.showUnInsl = false;
      this.currentUninstlSvc = '';
      this.GET_VENDOR();
    },
    openUnistallDialog(svcName) {
      this.showWindow = false;
      this.showUnInsl = true;
      this.currentUninstlSvc = svcName;
    },
    onUnistallDialogClose() {
      this.showUnInsl = false;
      this.currentUninstlSvc = '';
    },
  },
  watch: {
    installed(newVal) {
      if (!newVal || !Array.isArray(newVal)) return;
      const vendorsMap = {};
      const avalVendors = [];
      newVal.reduce((map, val) => {
        map[val.cloudVendor] = val.cloudVendor;
        return map;
      }, vendorsMap);
      const insalledVendors = [];
      this.avalVendors.reduce((obj, currVal) => {
        const vendorTemplate = this.chartsTemplate[currVal.name];
        vendorTemplate.isActive = currVal?.isActive;
        if (vendorTemplate) {
          if (vendorsMap[currVal.name] === undefined) obj.push(vendorTemplate);
          else insalledVendors.push(vendorTemplate);
        }
        return obj;
      }, avalVendors);
      if (insalledVendors.length < 1 && this.installedVendors.length > 0)
        return;
      this.installedVendors = insalledVendors;
      this.avalVendors = avalVendors;
      this.dataFetched = true;
    },
    available(newVal) {
      this.avalVendors = newVal;
      this.GET_INSTALLED_VENDORS();
    },
  },

  mounted() {
    this.GET_VENDOR();
  },
  computed: {
    ...mapState('globalState/app', ['chartsTemplate']),
    ...mapState('cloudState/integrations', [
      'installed',
      'available',
      'projects',
    ]),
    config() {
      return config;
    },
  },
  data() {
    return {
      avalIntegrations: 0,
      instllIntegrations: 0,
      installedVendors: [],
      avalVendors: [],
      showWindow: false,
      currentInstall: '',
      dataFetched: false,
      currentUninstlSvc: '',
      showUnInsl: false,
    };
  },
};
</script>
<style lang="scss">
.heading {
  font-size: 1.3rem;
  font-weight: bold;
}
.confirm-msg {
  font-size: 1.3rem;
  margin: 0rem;
}
.confirm-box {
  padding: 1rem;
  padding-left: 0rem;
}
.wrning-bx {
  background: #3c3d40;
  padding: 0.8rem;
}
.wring-text {
  margin: 0rem;
  color: $color-brand-accent;
  font-size: 1.2rem;
}
.cloud-settings-footer-btn {
  width: 100%;
}
</style>
